import { makeStyles } from "tss-react/mui";
import { FONT_WEIGHTS } from "@miplatform/constants";
import { Box, Typography } from "@mui/material";
import { MiIcon } from "../MiIcon/MiIcon";

export const WorkCardHeader = ({
  backgroundColor,
  title,
  attemptNumber,
  className = "",
  fontSize = "0.75rem",
  icon,
  isRequestedInDateRange,
  isInBucket,
}: {
  backgroundColor?: string;
  title: string;
  attemptNumber?: number;
  className?: string;
  fontSize?: string;
  icon?: { path: string; size?: number; color?: string } | null;
  isRequestedInDateRange?: boolean;
  isInBucket?: boolean;
}) => {
  const { classes, theme } = useStyles({
    backgroundColor,
    isRequestedInDateRange,
    isInBucket,
  });
  return (
    <Box className={`${classes.workCardHeader} ${className}`}>
      {icon && (
        <Box className={classes.iconContainer}>
          <MiIcon size={0.5} {...icon} />
        </Box>
      )}
      <Typography
        fontSize={fontSize}
        color={theme.palette.common.white}
        fontWeight={FONT_WEIGHTS.SEMIBOLD}
      >
        {title}
        {attemptNumber && `(#${attemptNumber})`}
      </Typography>
    </Box>
  );
};
const useStyles = makeStyles<{
  backgroundColor?: string;
  isInBucket?: boolean;
  isRequestedInDateRange?: boolean;
}>()((theme, { backgroundColor, isInBucket, isRequestedInDateRange }) => ({
  workCardHeader: {
    backgroundColor: backgroundColor ?? theme.palette.grey[800],
    padding: theme.spacing(0.5, 1),
    fontWeight: 600,
    display: "flex",
    alignItems: "center",
    gap: 4,
    textWrap: "nowrap",
    overflow: "hidden",
    ...(!isRequestedInDateRange &&
      isInBucket && {
        backgroundImage: `repeating-linear-gradient(135deg, rgba(0, 0, 0, 0.12) ${
          0 + 2.6251
        }px, rgba(0, 0, 0, 0.12) ${2 + 2.6251}px, transparent ${
          2 + 2.6251
        }px, transparent ${6 + 2.6251}px)`,
      }),
  },
  iconContainer: {
    backgroundColor: theme.palette.common.white,
    borderRadius: 4,
    padding: 2,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
}));
